$(function() {
    $('.o-js-multiple-select').select2({
        width: 'resolve'
    });
});